export enum CpfCnpjType {
	JURIDICA = 'juridica',
	FISICA = 'fisica'
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/enums/cpf-cnpj-type.ts